// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Panel de Administración SaaS - Super Admin
 * @file AdminDashboard.jsx
 * @description Shell ligero: solo React, state y lazy modules. Lógica pesada en modules/.
 * @version 2.0
 */

import { useState, lazy, Suspense } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { useTheme } from '../../context/ThemeContext';
import './AdminDashboard.css';

const TenantListModule = lazy(() => import('./modules/TenantList'));
const TenantDetailsModule = lazy(() => import('./modules/TenantDetails'));

/** Fallback mínimo para Suspense: sin LoadingScreen (evita brand, logger). */
const AdminModuleFallback = ({ t }) => (
  <div className="admin-loading">
    <div className="spinner" />
    <p>{t('common.loading')}</p>
  </div>
);

const AdminDashboard = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [selectedTenant, setSelectedTenant] = useState(null);
  const { theme: currentTheme } = useTheme();
  const isDark = currentTheme === 'dark';

  // Verificar que el usuario es super_admin
  const userRol = (user?.rol || '').toLowerCase();
  const isSuperAdmin = userRol === 'super_admin';

  if (!isSuperAdmin) {
    return (
      <div className={`admin-dashboard ${isDark ? 'dark-mode' : ''}`}>
        <div className="admin-access-denied">
          <h2>{t('admin.access_denied.title')}</h2>
          <p>{t('admin.access_denied.message')}</p>
        </div>
      </div>
    );
  }

  const handleTenantSelect = (tenant) => {
    setSelectedTenant(tenant);
  };

  const handleBackToList = () => {
    setSelectedTenant(null);
  };

  return (
    <div className={`admin-dashboard ${isDark ? 'dark-mode' : ''}`}>
      <div className="admin-header admin-header--navbar-title">
        <p className="admin-subtitle">{t('admin.subtitle')}</p>
      </div>

      <Suspense fallback={<AdminModuleFallback t={t} />}>
        {selectedTenant ? (
          <TenantDetailsModule
            tenantId={selectedTenant.tenant_id}
            onBack={handleBackToList}
          />
        ) : (
          <TenantListModule onSelectTenant={handleTenantSelect} />
        )}
      </Suspense>
    </div>
  );
};

export default AdminDashboard;
